import React from 'react';
import PropTypes from 'prop-types';
import colors from 'theme/_colors.scss';

const IconPreviousPage = ({ color = colors.deionizerBlack, width = 16, height = 16, viewBox = '0 0 16 16' }) => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox={viewBox} fill='none'>
            <path d='M6.5 2.5L8 4L4 8L8 12L6.5 13.5L1 8L6.5 2.5ZM13.5 2.5L15 4L11 8L15 12L13.5 13.5L8 8L13.5 2.5Z' fill={color} />
        </svg>
    );

};

IconPreviousPage.propTypes = {
    color: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    viewBox: PropTypes.string
};

export default IconPreviousPage;
